import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";

export default function Courses() {
  return (
    <Container className="py-5">
      <h1>Our Courses</h1>
      <Row className="mt-4">
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <Card.Body>
              <Card.Title>Course 1</Card.Title>
              <Card.Text>
                Learn the fundamentals of Course 1 with our expert faculty.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <Card.Body>
              <Card.Title>Course 2</Card.Title>
              <Card.Text>
                Gain practical knowledge and career skills in Course 2.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <Card.Body>
              <Card.Title>Course 3</Card.Title>
              <Card.Text>
                Advance your learning with specialized modules in Course 3.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
